import React from 'react';
import moment from 'moment';
import { useUser } from '../../hooks/use-user';

function Greetings() {
	const { getFirstName } = useUser();

	const currentHour = parseInt(moment().format('HH'), 10);
	let greeting = 'Goedemorgen';

	if (currentHour >= 18) {
		greeting = 'Goedeavond';
	} else if (currentHour >= 12) {
		greeting = 'Goedemiddag';
	}

	return (
		<h3 id="greetings">
			{greeting} {getFirstName()}
		</h3>
	);
}

export default Greetings;
